import CommonActions from './CommonActions/commonAction';


const Action ={
    CommonActions,
}
export default Action